export class LoadAuditLogs {
  static readonly type = '[AuditLog] Load Entries';
  constructor(public params?: Record<string, string>) {}
}
